import styled from 'styled-components';
import { fontSize, spacing } from 'theme';

export const StyledAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  color: inherit;
  gap: ${spacing('xs2')};
  margin-left: 105px;
  margin-top: ${spacing('xs')};
  font-size: ${fontSize('xs2')};
  line-height: 1;
`;
